export default "__VITE_ASSET__DkH9IotT__"